// src/pages/AdminLogin.js
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { adminLogin } from "../services/api";

function AdminLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");

  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    setError(""); // Clear any previous errors

    try {
      const result = await adminLogin(email, password);
      // Assuming result has { token, ... }
      if (result.token) {
        // Store the token in localStorage or your preferred storage
        localStorage.setItem("adminToken", result.token);

        // Redirect to Admin Dashboard
        navigate("/admin/dashboard");
      } else {
        setError("No token returned. Check server response.");
      }
    } catch (err) {
      console.error("Login error:", err);
      setError("Login failed. Please check credentials or server logs.");
    }
  };

  return (
    <div style={{ maxWidth: "400px", margin: "0 auto" }}>
      <h1>Admin Login</h1>
      <form onSubmit={handleLogin}>
        <div style={{ marginBottom: "1rem" }}>
          <label>
            Email:{" "}
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </label>
        </div>
        <div style={{ marginBottom: "1rem" }}>
          <label>
            Password:{" "}
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </label>
        </div>
        {error && (
          <div style={{ color: "red", marginBottom: "1rem" }}>
            {error}
          </div>
        )}
        <button type="submit">Log In</button>
      </form>
    </div>
  );
}

export default AdminLogin;
